import { useState } from 'react';
import { useIdentity } from '@gov-nx/auth/common/hooks/useIdentity';
import type { ExtraConfig } from '@gov-nx/core/app/extra-config/context.types';
import { propEq } from '@gov-nx/core/types/helpers.types';

export enum MySubmissionTabs {
	podani = 'podani',
	osvedceni = 'osvedceni',
	autorizace = 'autorizace',
}

export interface MySubmissionsBadge {
	nameCode: `filtr.zdroj.${MySubmissionTabs}`;
	tabCode: MySubmissionTabs;
	isVisible: boolean;
}

export const useMySubmissionTabs = (
	routesConfig: ExtraConfig['submissionsRoutes']['routesConfig']
) => {
	const loginInfo = useIdentity();
	const [mySubmissionSelectedTab, setMySubmissionSelectedTab] = useState(
		MySubmissionTabs.podani
	);

	const tabsRecord: Record<MySubmissionTabs, MySubmissionsBadge> = {
		[MySubmissionTabs.podani]: {
			nameCode: `filtr.zdroj.${MySubmissionTabs.podani}`,
			tabCode: MySubmissionTabs.podani,
			isVisible: routesConfig['podani'].isAvailable,
		},
		[MySubmissionTabs.osvedceni]: {
			nameCode: `filtr.zdroj.${MySubmissionTabs.osvedceni}`,
			tabCode: MySubmissionTabs.osvedceni,
			isVisible: !loginInfo.isLowLoa && routesConfig['osvedceni'].isAvailable,
		},
		[MySubmissionTabs.autorizace]: {
			nameCode: `filtr.zdroj.${MySubmissionTabs.autorizace}`,
			tabCode: MySubmissionTabs.autorizace,
			isVisible: routesConfig['autorizace'].isAvailable,
		},
	};

	const tabs: MySubmissionsBadge[] = Object.values(tabsRecord);

	return {
		mySubmissionSelectedTab,
		setMySubmissionSelectedTab,
		tabs: tabs.filter(propEq('isVisible', true)),
		isTabVisible: (tabCode: MySubmissionTabs) => tabsRecord[tabCode].isVisible,
		tabLabel: (tabCode: MySubmissionTabs) => tabsRecord[tabCode].nameCode,
	};
};
